import { Component, OnInit, Input } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import {
  User,
  PreferenceKey,
  UserPreference,
  ServiceType
} from '@sabstravtech/obtservices/angular';
import { PREFERENCE_VALUES, PreferenceValue } from '@sabstravtech/obtservices/base';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';

import { BaseComponent } from '../../core/components/base_components/base-componet';

@Component({
  selector: 'app-profile-information-travel-preferences',
  templateUrl: './profile-information-travel-preferences.component.html',
  styleUrls: ['./profile-information-travel-preferences.component.scss'],
  standalone: false
})
export class ProfileInformationTravelPreferencesComponent extends BaseComponent implements OnInit {
  faChevronDown = faChevronDown;
  @Input() user: User;
  @Input() travelPreferencesForm: FormGroup;
  @Input() isEditable: boolean;

  mealRequest: PreferenceValue[];
  seatingPreference: PreferenceValue[];
  specialNeed: PreferenceValue[];
  seatLocation: PreferenceValue[];
  seatPosition: PreferenceValue[];
  seatDirection: PreferenceValue[];
  flightNotifications: PreferenceValue[];

  preferenceKeyEnum = PreferenceKey;

  constructor(
    title: Title,
    translateService: TranslateService,
    private fb: FormBuilder
  ) {
    super(title, translateService);
  }

  get preferences() {
    return this.travelPreferencesForm.controls['preferences'] as FormArray;
  }

  ngOnInit(): void {
    this.mealRequest = PREFERENCE_VALUES.filter(
      (pref: PreferenceValue) => pref.type === PreferenceKey.MealRequest
    );
    this.specialNeed = PREFERENCE_VALUES.filter(
      (pref: PreferenceValue) => pref.type === PreferenceKey.SpecialNeed
    );
    this.seatingPreference = PREFERENCE_VALUES.filter(
      (pref: PreferenceValue) => pref.type === PreferenceKey.SeatingPreference
    );
    this.seatLocation = PREFERENCE_VALUES.filter(
      (pref: PreferenceValue) => pref.type === PreferenceKey.SeatLocation
    );
    this.seatPosition = PREFERENCE_VALUES.filter(
      (pref: PreferenceValue) => pref.type === PreferenceKey.SeatPosition
    );
    this.seatDirection = PREFERENCE_VALUES.filter(
      (pref: PreferenceValue) => pref.type === PreferenceKey.SeatDirection
    );
    this.flightNotifications = PREFERENCE_VALUES.filter(
      (pref: PreferenceValue) => pref.type === PreferenceKey.FlightNotificationsEnabled
    );
    if (this.user && !this.preferences.value.length) {
      this.setValue();
    }
    if (!this.isEditable) {
      this.travelPreferencesForm.disable();
    }
  }

  setValue() {
    this.travelPreferencesForm.setValue({
      preferences: []
    });

    const defaultPreferences = [
      {
        serviceType: ServiceType.Flight,
        preferenceKey: PreferenceKey.FlightNotificationsEnabled,
        preferenceValue: '',
        code: ''
      },
      {
        serviceType: ServiceType.Flight,
        preferenceKey: PreferenceKey.SpecialNeed,
        preferenceValue: '',
        code: ''
      },
      {
        serviceType: ServiceType.Flight,
        preferenceKey: PreferenceKey.MealRequest,
        preferenceValue: '',
        code: ''
      },
      {
        serviceType: ServiceType.Flight,
        preferenceKey: PreferenceKey.SeatingPreference,
        preferenceValue: '',
        code: ''
      },
      {
        serviceType: ServiceType.Rail,
        preferenceKey: PreferenceKey.SeatDirection,
        preferenceValue: '',
        code: ''
      },
      {
        serviceType: ServiceType.Rail,
        preferenceKey: PreferenceKey.SeatPosition,
        preferenceValue: '',
        code: ''
      },
      {
        serviceType: ServiceType.Rail,
        preferenceKey: PreferenceKey.SeatLocation,
        preferenceValue: '',
        code: ''
      }
    ] as UserPreference[];

    defaultPreferences.forEach((defaultPref: UserPreference) => {
      const existingPref = this.user.preferences?.find(
        (p) => p.preferenceKey === defaultPref.preferenceKey
      );
      this.addPreference(existingPref || defaultPref);
    });
  }

  addPreference(preference: UserPreference) {
    let normalisedValue = preference.preferenceValue;

    if (normalisedValue && preference.preferenceKey === PreferenceKey.MealRequest) {
      let matchingPref = this.mealRequest?.find(
        (pref) => pref.label.toLowerCase() === preference.preferenceValue.toLowerCase()
      );

      if (!matchingPref) {
        const codeMatch = preference.preferenceValue.match(/\(([A-Z]{4})\)/);
        if (codeMatch) {
          matchingPref = this.mealRequest?.find((pref) => pref.code === codeMatch[1]);
        }
      }

      if (matchingPref) {
        normalisedValue = matchingPref.label;
      }
    }

    const preferenceForm = this.fb.group({
      serviceType: [preference.serviceType],
      preferenceKey: [preference.preferenceKey],
      preferenceValue: [normalisedValue],
      code: preference.code
    });
    this.preferences.push(preferenceForm);
  }
}
